import React from "react";
import { WebAppInstructions } from "./web_app_instructions.jsx";
import { EmailInstructions } from "./email_instructions.jsx";

export const HowToPrint = ({ email }) => {
  return (
    <section>
      <div className="my-4">
        <h2 className="text-center text-sm-start">How To Print</h2>
      </div>

      <div>
        <WebAppInstructions />
      </div>

      <div>
        <EmailInstructions email={email} />
      </div>
    </section>
  );
};
